export enum Routes {
  UserRouter = "*",
  UserSearchPageRouter = "/user/search",
  UserDetailPageRouter = '/user/:id/detail/',
  UserEditPageRouter = '/user/:id/edit/',
  UserCreatePageRouter = '/user/new',
  UserPermissionSearchPageRouter = '/user/:id/permission/',
  UserPermissionCreatePageRouter = '/user/:userid/permission/create/',
  UserPermissionEditPageRouter = '/user/:userid/permission/:id/edit/',
}




